import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ExprUtils } from '@/common/utils/ExprUtils';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const InctvLedgerLineList = ({ inctvLedgerObj: inctvLedger }) => {
  const augRowsReq = useCallback((rowsReq) => {
    if (!inctvLedger?.id) return;
    rowsReq.expr = ExprUtils.and(rowsReq.expr, ExprUtils.whereParams('inctvLedgerId', inctvLedger.id));
  }, []);

  const augTabButtons = (tabButtons) => {
    ObjUtils.clearObj(tabButtons);
  };

  return <EntityList entity="INCTV_LEDGER_LINE" augRowsReq={augRowsReq} augTabButtons={augTabButtons} />;
};
